<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <!-- Loading -->
          <transition name="load">
            <SmallLoadingLogo v-if="loading" />
          </transition>
          <div class="modal-header">
            <slot name="header">
              <!-- default header -->
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              default body
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <!-- default footer -->
              <!-- <button class="modal-default-button" @click="$emit('close')">
                OK
              </button> -->
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import SmallLoadingLogo from "./SmallLoadingLogo.vue";

export default {
  name: "modal-template",
  props: {
      loading: Boolean
  },
  components: {
    SmallLoadingLogo,
  },
};
</script>
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  position: relative;
  min-width: 300px;
  width: fit-content;
  margin: 0px auto;
  padding: 10px;
  background-color: rgb(40, 42, 59);
  border: solid 2px white;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  /* margin: 20px 0; */
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
